import { c as _c } from "react/compiler-runtime";
import type { BeachAmenities } from '@data-access/graphql/schema.types';
import type { Icon } from '@phosphor-icons/react';
import { Bicycle, Boat, Bone, Car, CoatHanger, ForkKnife, IceCream, Martini, Newspaper, PersonSimpleThrow, Shower, Toilet, Volleyball, Warehouse, Wheelchair, WifiHigh } from '@phosphor-icons/react';
const BEACH_CHAIR_AMENITY_LABELS: Record<string, string> = {
  CarParking: 'Parkplatz',
  Dogs: 'Hunde',
  DressingRoom: 'Umkleiden',
  Drinks: 'Getränke',
  Food: 'Gastronomie',
  FreeMagazin: 'Zeitungen',
  Ice: 'Eis',
  Nude: 'FKK',
  PedalBoat: 'Bootsverleih',
  Playground: 'Spielplatz',
  RentalBikes: 'Fahrradverleih',
  RentingToy: 'Spielzeug',
  Showers: 'Duschen',
  Wc: 'Toiletten',
  WheelChair: 'Barrierefrei',
  Wlan: 'WLAN',
  showLess: 'Weniger anzeigen',
  showMore: 'Mehr anzeigen',
  title: 'Was gibt es hier?'
};
export const iconMapping: Record<BeachAmenities, Icon> = {
  'CarParking': Car,
  'Dogs': Bone,
  'DressingRoom': Warehouse,
  'Drinks': Martini,
  'Food': ForkKnife,
  'FreeMagazin': Newspaper,
  'Ice': IceCream,
  'Nude': CoatHanger,
  'PedalBoat': Boat,
  'Playground': PersonSimpleThrow,
  'RentalBikes': Bicycle,
  'RentingToy': Volleyball,
  'Showers': Shower,
  'Wc': Toilet,
  'WheelChair': Wheelchair,
  'Wlan': WifiHigh
};
type BeachChairAmenityProps = {
  Icon: Icon;
  amenity: BeachAmenities;
};
export function BeachChairAmenity(t0) {
  const $ = _c(7);
  const {
    Icon,
    amenity
  } = t0;
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon size={24} className="shrink-0" alt="" role="presentation" />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = BEACH_CHAIR_AMENITY_LABELS[amenity] ?? amenity;
  let t3;
  if ($[2] !== t2) {
    t3 = <p className="font-body-copy">{t2}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}